export enum OfferDesignTypes {
  SpecialOffer = 'SpecialOffer',
  Bundle = 'Bundle',
  PopUp = 'PopUp',
  TriggeredPopup = 'TriggeredPopup',
  RollingOffer = 'RollingOffer',
  ProgressBar = 'ProgressBar'
}

export interface OfferDesignTypeItem {
  content: string;
  key: OfferDesignTypes;
  value: OfferDesignTypes;
}

export interface OffersUIFormProps {
  edit?: boolean;
  dup?: boolean;
}
